document.addEventListener('DOMContentLoaded', function () {
  var widget = document.querySelector('[data-chatbot]');
  if (!widget) return;

  var toggleBtn = widget.querySelector('[data-chatbot-toggle]');
  var closeBtn = widget.querySelector('[data-chatbot-close]');
  var body = widget.querySelector('[data-chatbot-body]');
  var questionsWrap = widget.querySelector('[data-chat-questions]');

  var originalQuestionsHTML = questionsWrap ? questionsWrap.outerHTML : '';

  function openChat() {
    widget.classList.add('is-open');
  }

  function closeChat() {
    widget.classList.remove('is-open');
  }

  toggleBtn.addEventListener('click', function () {
    if (widget.classList.contains('is-open')) {
      closeChat();
    } else {
      openChat();
    }
  });

  if (closeBtn) closeBtn.addEventListener('click', closeChat);

  function attachQuestionListeners(container) {
    container.querySelectorAll('.chat-quick-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var question = btn.getAttribute('data-question');
        var answer = btn.getAttribute('data-answer');
        handleQuestionClick(question, answer);
      });
    });
  }

  function handleQuestionClick(question, answer) {
    /* Remove current quick replies */
    var currentReplies = body.querySelector('.chat-quick-replies');
    if (currentReplies) currentReplies.remove();

    var backBtn = body.querySelector('.chat-back-btn');
    if (backBtn) backBtn.remove();

    /* Add user question bubble */
    var userMsg = document.createElement('div');
    userMsg.className = 'chat-message user';
    userMsg.innerHTML = '<p>' + question + '</p>';
    body.appendChild(userMsg);

    /* Add typing indicator briefly, then answer */
    setTimeout(function () {
      var botMsg = document.createElement('div');
      botMsg.className = 'chat-message bot';
      botMsg.innerHTML = '<p>' + answer + '</p>';
      body.appendChild(botMsg);

      /* Add a "back to questions" button */
      var back = document.createElement('button');
      back.type = 'button';
      back.className = 'chat-back-btn';
      back.innerHTML = '&larr; Ask another question';
      back.addEventListener('click', function () {
        var newReplies = document.createElement('div');
        newReplies.innerHTML = originalQuestionsHTML;
        var newWrap = newReplies.firstElementChild;
        body.appendChild(newWrap);
        attachQuestionListeners(newWrap);
        back.remove();
        body.scrollTop = body.scrollHeight;
      });
      body.appendChild(back);

      body.scrollTop = body.scrollHeight;
    }, 500);

    body.scrollTop = body.scrollHeight;
  }

  attachQuestionListeners(body);
});